module.exports = __webpack_public_path__ + "img/19.095386c2.png";